export const api_url = "https://mm.paridax.xyz";
export const web_url = "https://mm.paridax.xyz/";